import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { leadRankFilterConfig } from '../../../configs/lead-rank-filter-config';

export const LeadRankFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Rank'
      config={leadRankFilterConfig}
    />
  );
};
